module.exports = __webpack_public_path__ + "img/turbo_off.150cafc2.png";